import BaseClass from './BaseClass';

export const EVENTS = {
  onSubscriptionError: 'onSubscriptionError',
  onSubscriptionUpdateNotification: 'onSubscriptionUpdateNotification',
  onStatusChange: 'onStatusChange',
};
export class Subscription extends BaseClass {
  /**
   * Subscription Object, Responsible for handling a stream of data
   * based on filters.
   */
  constructor(config) {
    super({
      name: `Subscription[${config.name}]`,
    });

    this.handlers = config.handlers;
    this.resourceName = config.resourceName;
  }

  async start(settings) {
    if (this.handlers && this.handlers.start) {
      this.handlers.start.call(this, settings || {});
    } else {
      this.throwError({ message: 'Subscription Configuration: Missing start handler', graphName: 'missingSubscriptionHandlers' });
    }
  }

  async stop(settings) {
    if (this.handlers && this.handlers.stop) {
      this.handlers.stop.call(this, settings || {});
    } else {
      this.throwError({ message: 'Subscription Configuration: Missing stop handler', graphName: 'missingSubscriptionHandlers' });
    }
  }

  async update(settings) {
    if (this.handlers && this.handlers.update) {
      // optimized handler for update the subscriptions
      await this.handlers.update(settings);
    } else {
      // generic update of the subscription
      await this.stop(settings);
      await this.start(settings);
    }
  }
  clearAllEventListeners() {
    this.clearAllListeners(Subscription.EVENTS.onSubscriptionUpdateNotification);
    this.clearAllListeners(Subscription.EVENTS.onSubscriptionError);
  }
}

// setup static event referencing
Subscription.EVENTS = EVENTS;
